import { useContext } from 'react';
import { createContext } from 'react';

import { ConditionLayoutProductProps } from '../@types/ConditionLayoutProductProps';

export const ConditionLayoutProductContext = createContext<ConditionLayoutProductProps>(
	{} as ConditionLayoutProductProps,
);

ConditionLayoutProductContext.displayName = 'ConditionLayoutProduct';

const ConditionLayoutProductProvider = (props: ConditionLayoutProductProps) => (
	<ConditionLayoutProductContext.Provider value={props}>{props.children}</ConditionLayoutProductContext.Provider>
);

export const useConditionLayoutProduct = () => {
	const context = useContext(ConditionLayoutProductContext);

	return context;
};

export default ConditionLayoutProductProvider;
